module.exports = __webpack_public_path__ + "media/styles/images/svg/courses-teal-4e1d0ca54898096edae71d355f115e92.svg";